import React from 'react'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import InputLabel from '@material-ui/core/InputLabel'
// @material-ui/icons
import PermIdentity from '@material-ui/icons/PermIdentity'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import CustomInput from 'components/CustomInput/CustomInput.jsx'
import Clearfix from 'components/Clearfix/Clearfix.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'

import styles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles'


import AutoCompleteDropdown from 'components/CustomDropdown/AutoCompleteDropdown'
// general api
import { insertOne, updateOne } from '../../services/generalServiceAPI'

import { jsonPP, noError, handleResponseOfSaving, generateOptionsFromStringArray } from '../utility/utility'
import swal from 'sweetalert'

import { GeneralData } from 'staticConfig.js'

const countryOptions = generateOptionsFromStringArray(GeneralData.country.map(c => c.name))

class CompanyProfile extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: {
        title: 'Create Company',
        button: 'Create'
      },
      data: {
        tableName: 'companies',
        id: '',
        name: '',
        country: 'Canada',
        short: '',
        description: ''
      },
      dataState: {
        name: '',
        short: ''
      },
      dirty: false
    }

    this.save = this.save.bind(this)
    this.change = this.change.bind(this)
  }
  getOnlyLabelFromDropdown = name => value => {
    //  logger('GAT: loadPathInfo',value)
    const { data, dataState } = this.state
    data[name] = value.label
    dataState[name] = 'success'
    this.setState({
      dirty: true,
      data,
      dataState
    })
  }
  change(event) {
    this.setState({
      data: { ...this.state.data, [event.target.id]: event.target.value }
    })
    if (!this.state.dirty) this.setState({ dirty: true })
  }

  save() {
    if (this.state.data.name === '') {
      this.setState({ dataState: { name: 'error' } })
    }

    if (this.state.dirty) {
      if (noError(this.state.dataState)) {
        const insertOrModify = data => (data.id !== '' ? updateOne(data) : insertOne(data))
        const { tableName, ...rest } = this.state.data
        insertOrModify({ tableName, ...rest })
          .then(response => {
            handleResponseOfSaving(response, this.props.refetch)
          })
          .catch(e => swal(`General api throw error: ${e}`))
      } else swal('Please fix the error on the page first.')
    }

    this.props.hideEditProfile()
  }
  componentDidMount() {
    const { id, name, country, short, description } = this.props.data
    if (id !== '' && id !== this.state.data.id) {
      this.setState({
        text: {
          title: 'Update Company',
          button: 'Update'
        },
        data: {
          ...this.state.data,
          id,
          name,
          country,
          short,
          description
        }
      })
    }
  }

  render() {
    const { classes } = this.props

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  {this.state.text.title} <small />
                </h4>
              </CardHeader>
              <CardBody>
                <form>
                  {/**   name*/}
                  <GridContainer>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        success={this.state.dataState.nameState === 'success'}
                        error={this.state.dataState.nameState === 'error'}
                        labelText="Company Name"
                        id="name"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          disabled: false,
                          value: this.state.data.name,
                          onChange: event => this.change(event),
                          type: 'text'
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={3} >
                      <CustomInput
                        success={this.state.dataState.shortState === 'success'}
                        error={this.state.dataState.shortState === 'error'}
                        labelText="Abbr."
                        id="short"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          disabled: false,
                          value: this.state.data.short,
                          onChange: event => this.change(event),
                          type: 'text'
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={3}>
                      <AutoCompleteDropdown
                        value={this.state.data.country}
                        //isDisabled={this.isSubmitted()}
                        options={countryOptions}
                        loose
                        placeholder={'Select Country'}
                        onChange={this.getOnlyLabelFromDropdown('country')}
                      />
                    </GridItem>
                  </GridContainer>

                  {/* about */}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <InputLabel style={{ color: '#AAAAAA' }}>Company briefs</InputLabel>
                      <CustomInput
                        // labelText="Anything you want to say about this company."
                        id="description"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          multiline: true,
                          value: this.state.data.description,
                          onChange: event => this.change(event),
                          rows: 5
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <Button color="rose" className={classes.updateProfileButton} onClick={this.save}>
                    {this.state.text.button}
                  </Button>
                  <Clearfix />
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {jsonPP(this.state.data)}
      </div>
    )

  }
}

export default withStyles(styles)(CompanyProfile)
